/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/system";
import { useEffect, useState, useContext } from "react";
import Message from "../../utils/Message";
import LcProductoDialog from "./LcProductoDialog";
import { getLcProductos, getLcProducto } from "../../services/LcProductoService";
import { getCacheData } from "../../services/CacheService";
import { getLcSubMarcas } from "../../services/LcSubMarcaService";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  descripcion: "",
  descripcionCorta: "",
  idLcMarca: null,
  idLcSubmarca: null,
  idLcDiagnostico: null,
  idLcMaterial: null,
  idLcTiempoUso: null,
  idLcTipo: null,
  idLcMultifocal: null,
  idLcColor: null,
  idLcDisponibleOs: null,
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const multifocalOptions = [
  {
    id: "todo",
    descripcion: "Todos",
  },
  {
    id: "si",
    descripcion: "Si",
  },
  {
    id: "no",
    descripcion: "No",
  },
];

const disponibleOsOptions = [
  {
    id: "todo",
    descripcion: "Todos",
  },
  {
    id: "si",
    descripcion: "Si",
  },
  {
    id: "no",
    descripcion: "No",
  },
];

const nameItemsText = "Productos de Lente de Contacto";
//
// #############################################################################
//
const LcProductoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [lcMarcas, setLcMarcas] = useState([]);
  const [lcSubMarcas, setLcSubMarcas] = useState([]);
  const [lcDiagnosticos, setLcDiagnosticos] = useState([]);
  const [lcMateriales, setLcMateriales] = useState([]);
  const [lcTiemposUso, setLcTiemposUso] = useState([]);
  const [lcTipos, setLcTipos] = useState([]);
  const [lcColores, setLcColores] = useState([]);
  const [isSearching, setIsSearching] = useState(false)
  const [valueACLcMarca, setValueACLcMarca] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcMarca, setInputValueACLcMarca] = useState("");
  const [valueACLcSubMarca, setValueACLcSubMarca] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcSubMarca, setInputValueACLcSubMarca] = useState("");

  const [valueACLcDiagnostico, setValueACLcDiagnostico] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcDiagnostico, setInputValueACLcDiagnostico] = useState("");

  const [valueACLcMaterial, setValueACLcMaterial] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcMaterial, setInputValueACLcMaterial] = useState("");

  const [valueACLcTiempoUso, setValueACLcTiempoUso] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcTiempoUso, setInputValueACLcTiempoUso] = useState("");

  const [valueACLcTipo, setValueACLcTipo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcTipo, setInputValueACLcTipo] = useState("");

  const [valueACLcMultifocal, setValueACLcMultifocal] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcMultifocal, setInputValueACLcMultifocal] = useState("");

  const [valueACLcColor, setValueACLcColor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcColor, setInputValueACLcColor] = useState("");

  const [valueACLcDisponibleOs, setValueACLcDisponibleOs] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcDisponibleOs, setInputValueACLcDisponibleOs] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearLcProducto = hasPermission("lc-producto-c");
  const _editarLcProducto = hasPermission("lc-producto-e");
  const _habilitarLcProducto = hasPermission("lc-producto-h");
  const _deshabilitarLcProducto = hasPermission("lc-producto-d");

  const tableColumns = [
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_submarca",
      headerName: "Submarca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_submarca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_diagnostico",
      headerName: "Diagnóstico",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_diagnostico;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_material",
      headerName: "Material",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_material;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_tiempo_uso",
      headerName: "Tpo Uso",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_tiempo_uso;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "multifocal",
      headerName: "Multifocal",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.multifocal;
        if (_val === false) {
          _val = "NO";
        } else if (_val === true) {
          _val = "SI";
        } else {
          _val = "";
        }
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_color",
      headerName: "Color",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_color;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarLcProducto && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarLcProducto && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarLcProducto && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadLcMarcas();
    loadLcDiagnosticos();
    loadLcMateriales();
    loadLcTiemposUso();
    loadLcTipos();
    loadLcColores();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  useEffect(() => {
    setValueACLcSubMarca(null);
    if (valueACLcMarca.id && valueACLcMarca.id !== "") {
      loadLcSubMarcas(valueACLcMarca.id);
    }
  }, [valueACLcMarca]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueACLcMarca({
      id: "",
      descripcion: "",
    });
    setValueACLcDiagnostico({
      id: "",
      descripcion: "",
    });
    setValueACLcMaterial({
      id: "",
      descripcion: "",
    });
    setValueACLcTiempoUso({
      id: "",
      descripcion: "",
    });
    setValueACLcTipo({
      id: "",
      descripcion: "",
    });
    setValueACLcMultifocal({
      id: "todo",
      descripcion: "Todos",
    });
    setValueACLcColor({
      id: "",
      descripcion: "",
    });
    setValueACLcDisponibleOs({
      id: "todo",
      descripcion: "Todos",
    });

    setItemsCrud([]);
    setLcSubMarcas([]);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      descripcion: searchData.descripcion,
      descripcionCorta: searchData.descripcionCorta,
      idLcMarca: searchData.idLcMarca,
      idLcSubmarca: searchData.idLcSubmarca,
      idLcDiagnostico: searchData.idLcDiagnostico,
      idLcMaterial: searchData.idLcMaterial,
      idLcTiempoUso: searchData.idLcTiempoUso,
      idLcTipo: searchData.idLcTipo,
      idLcMultifocal: searchData.idLcMultifocal ? searchData.idLcMultifocal : "T",
      idLcColor: searchData.idLcColor,
      idLcDisponibleOs: searchData.idLcDisponibleOs ? searchData.idLcDisponibleOs : "T",
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getLcProductos(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    let _itemCrud = {};

    if (action !== "new") {
      const loadItem = async () => {
        setIsDoingSomething(true);
        setIsSearching(true);
        const response = await getLcProducto({ id: itemCrud.id });

        if (response.ok) {
          // let _response = response.data.data[0];
          setIsDoingSomething(false);
          let _response = response.data.data;
          _itemCrud = {
            id: _response.id,
            descripcion: _response.descripcion,
            descripcionCorta: _response.descripcion_corta,
            idLcMarca: _response.id_lc_marca,
            observaciones: _response.observaciones,
            lcMarca: {
              id: _response.id_lc_marca,
              label: _response.descripcion_lc_marca

            },
            lcSubMarca: {
              id: _response.id_lc_submarca,
              label: _response.descripcion_lc_submarca

            },
            lcDiagnostico: {
              id: _response.id_lc_diagnostico,
              label: _response.descripcion_lc_diagnostico

            },
            lcMaterial: {
              id: _response.id_lc_material,
              label: _response.descripcion_lc_material

            },
            lcTiempoUso: {
              id: _response.id_lc_tiempo_uso,
              label: _response.descripcion_lc_tiempo_uso

            },
            lcTipo: {
              id: _response.id_lc_tipo,
              label: _response.descripcion_lc_tipo

            },
            multifocal: _response.multifocal,
            disponibleOs: _response.disponible_obra_social,
            lcColor: {
              id: _response.id_lc_color,
              label: _response.descripcion_lc_color

            },
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setIsSearching(false);
          setOpenDialog(true);
        } else {
          setIsDoingSomething(false);
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
      setIsSearching(false);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadLcMarcas = async () => {
    const response = await getCacheData("lc_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcMarcas(_var);
    } else {
      setLcMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcSubMarcas = async (idLcMarca) => {
    setIsDoingSomething(true);
    const response = await getLcSubMarcas({ idLcMarca: idLcMarca });

    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcSubMarcas(_var);
    } else {
      setIsDoingSomething(false);
      setLcSubMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcDiagnosticos = async () => {
    const response = await getCacheData("lc_diagnostico")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcDiagnosticos(_var);
    } else {
      setLcDiagnosticos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcMateriales = async () => {
    const response = await getCacheData("lc_material")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcMateriales(_var);
    } else {
      setLcMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcTiemposUso = async () => {
    const response = await getCacheData("lc_tiempo_uso")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcTiemposUso(_var);
    } else {
      setLcTiemposUso([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcTipos = async () => {
    const response = await getCacheData("lc_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcTipos(_var);
    } else {
      setLcTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcColores = async () => {
    setIsDoingSomething(true);
    const response = await getCacheData("lc_color");

    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcColores(_var);
    } else {
      setIsDoingSomething(false);
      setLcColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripcion"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={searchData.descripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcionCorta"
                  label="Descripcion Abreviada"
                  variant="outlined"
                  size="small"
                  name="descripcionCorta"
                  value={searchData.descripcionCorta}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-marca-producto"
                  size="small"
                  value={
                    valueACLcMarca && valueACLcMarca.id
                      ? valueACLcMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcMarca(newValue);
                    setSearchData({
                      ...searchData,
                      idLcMarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcMarca(newInputValue);
                  }}
                  options={lcMarcas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Marca del Producto" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-sub-marca-producto"
                  size="small"
                  value={
                    valueACLcSubMarca && valueACLcSubMarca.id
                      ? valueACLcSubMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcSubMarca(newValue);
                    setSearchData({
                      ...searchData,
                      idLcSubmarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcSubMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcSubMarca(newInputValue);
                  }}
                  options={lcSubMarcas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="SubMarca del Producto" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-diagnostio"
                  size="small"
                  value={
                    valueACLcDiagnostico && valueACLcDiagnostico.id
                      ? valueACLcDiagnostico
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcDiagnostico(newValue);
                    setSearchData({
                      ...searchData,
                      idLcDiagnostico: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcDiagnostico}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcDiagnostico(newInputValue);
                  }}
                  options={lcDiagnosticos}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Diagnóstico" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-material"
                  size="small"
                  value={
                    valueACLcMaterial && valueACLcMaterial.id
                      ? valueACLcMaterial
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcMaterial(newValue);
                    setSearchData({
                      ...searchData,
                      idLcMaterial: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcMaterial}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcMaterial(newInputValue);
                  }}
                  options={lcMateriales}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Material" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tiempo-uso"
                  size="small"
                  value={
                    valueACLcTiempoUso && valueACLcTiempoUso.id
                      ? valueACLcTiempoUso
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcTiempoUso(newValue);
                    setSearchData({
                      ...searchData,
                      idLcTiempoUso: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcTiempoUso}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcTiempoUso(newInputValue);
                  }}
                  options={lcTiemposUso}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Tiempo de Uso" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tipo"
                  size="small"
                  value={
                    valueACLcTipo && valueACLcTipo.id
                      ? valueACLcTipo
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcTipo(newValue);
                    setSearchData({
                      ...searchData,
                      idLcTipo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcTipo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcTipo(newInputValue);
                  }}
                  options={lcTipos}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Tipo" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-multifocal"
                  size="small"
                  value={
                    valueACLcMultifocal && valueACLcMultifocal.id
                      ? valueACLcMultifocal
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcMultifocal(newValue);
                    setSearchData({
                      ...searchData,
                      idLcMultifocal: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcMultifocal}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcMultifocal(newInputValue);
                  }}
                  options={multifocalOptions}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Multifocal" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-color"
                  size="small"
                  value={
                    valueACLcColor && valueACLcColor.id
                      ? valueACLcColor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcColor(newValue);
                    setSearchData({
                      ...searchData,
                      idLcColor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcColor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcColor(newInputValue);
                  }}
                  options={lcColores}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Color" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-disponible-os"
                  size="small"
                  value={
                    valueACLcDisponibleOs && valueACLcDisponibleOs.id
                      ? valueACLcDisponibleOs
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcDisponibleOs(newValue);
                    setSearchData({
                      ...searchData,
                      idLcDisponibleOs: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcDisponibleOs}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcDisponibleOs(newInputValue);
                  }}
                  options={disponibleOsOptions}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Disponible Obra Social" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-documento-select-label">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearLcProducto && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo producto de lente de contacto">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <LcProductoDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default LcProductoTable;
